<template>
  <main>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <form-select :model="filterFormModel" attribute="appliedTo" :errors="formErrors" v-if="!department && !group"
                         :options="appliedToOptions" class="mr-1 mb-1"></form-select>
            <department-select v-if="!department && !group && filterFormModel.appliedTo === 'department'" :model="filterFormModel" class="mr-1 mb-1"></department-select>
            <group-select v-if="!group && !department && filterFormModel.appliedTo === 'group'" :model="filterFormModel" class="mr-1 mb-1"></group-select>
            <form-select :model="filterFormModel" attribute="month" :error="formErrors" :options="monthOptions" class="mr-1 mb-1"></form-select>
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.year" v-on:keydown.enter="load"
                          :placeholder="$t('year')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting" v-if="['owner', 'admin', 'account', 'operationsManager'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('appliedTo') }}</div>
            <div class="col-lg-3">{{ $t('appliedTime') }}</div>
            <div class="col-lg-3">{{ $t('sales') }}</div>
            <div class="col-lg-3"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <p v-if="item.appliedTo === 'group' && item.group" ><b>{{ $t('appliedToGroup') }}: </b><span>{{ item.group.name }}</span></p>
              <p v-if="item.appliedTo === 'department' && item.department"><b>{{ $t('appliedToDepartment') }}: </b><span>{{ item.department.name }}</span></p>
            </div>
            <div class="col-lg-3">
              <p><b>{{ $t('month') }}: </b><span>{{ item.month }}</span></p>
              <p><b>{{ $t('year') }}: </b><span>{{ item.year }}</span></p>
            </div>
            <div class="col-lg-3">
              <div>
                <b>{{$t('salesTarget')}}: </b>
                <span>{{ item.salesTarget | numFormat }}</span>
              </div>
              <div>
                <b>{{$t('salesAchieved')}}: </b>
                <span>{{ item.salesAchieved | numFormat }}</span>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button @click="update(item._id)" type="button"
                            v-if="['owner', 'admin', 'account', 'operationsManager'].includes($store.state.user.role) && check(item)"
                            class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button"
                            v-if="['owner', 'admin', 'operationsManager'].includes($store.state.user.role) && !item.salesAchieved && check(item)"
                            class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>

      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle + ' ' + getFormTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <form-select :model="formModel" attribute="appliedTo" :errors="formErrors" :label="$t('appliedTo')"
                   :options="appliedToOptions" v-if="!department && !group" :disabled="formModel.id"></form-select>
      <department-select :model="formModel" attribute="department" :errors="formErrors"
                         v-if="!department && !group && formModel.appliedTo==='department'" :disabled="formModel.id">
      </department-select>
      <group-select :model="formModel" attribute="group" :errors="formErrors"
                    v-if="!department && !group && formModel.appliedTo === 'group'" :disabled="formModel.id">
      </group-select>
      <form-select :model="formModel" attribute="month" :label="$t('month')" :error="formErrors" :options="monthOptions"></form-select>
      <form-input :model="formModel" attribute="year" :label="$t('year')" :errors="formErrors"></form-input>
      <form-input :model="formModel" attribute="salesTarget" :label="$t('salesTarget')"
                  :errors="formErrors"></form-input>
    </b-modal>
  </main>
</template>

<script>
import List from '@/mixins/List';
import CRUD from "@/mixins/CRUD";
import moment from "moment";
import GroupSelect from "@/components/GroupSelect";
import DepartmentSelect from "@/components/DepartmentSelect";

export default {
  components: {DepartmentSelect, GroupSelect},
  props: {
    group: Object,
    department: Object
  },
  mixins: [List, CRUD],
  data() {
    return {
      service: '/kpi-setup',
      autoLoad: true,
      defaultFilterFormModel: {
        month: null,
        year: null,
        group: this.group ? this.group._id : null,
        department: this.department ? this.department._id : null,
        appliedTo: this.group ? 'group' : this.department ? 'department' : null
      },
      defaultFormModel: {
        group: this.group ? this.group._id : null,
        department: this.department ? this.department._id : null,
        appliedTo: this.group ? 'group' : this.department ? 'department' : null
      },
      monthOptions: [
        {value: null, text: this.$t('chooseMonth')},
        {value: 1, text: 1},
        {value: 2, text: 2},
        {value: 3, text: 3},
        {value: 4, text: 4},
        {value: 5, text: 5},
        {value: 6, text: 6},
        {value: 7, text: 7},
        {value: 8, text: 8},
        {value: 9, text: 9},
        {value: 10, text: 10},
        {value: 11, text: 11},
        {value: 12, text: 12},
      ],
      appliedToOptions: [
        {value: null, text: this.$t('chooseAppliedTo')},
        {value: 'department', text: this.$t('appliedToDepartment')},
        {value: 'group', text: this.$t('appliedToGroup')}
      ]
    }
  },
  methods: {
    check(item) {
      let itemMonth = moment([item.year, item.month-1]).endOf('month');
      return Date.now() <= itemMonth;
    },
  },
  computed: {
    getFormTitle() {
      let str = this.$t('kpiSetup')
      if (this.group && this.group.name) {
        str += ': ' + this.$t('group') + ' ' + this.group.name;
      }
      if (this.department && this.department.name) {
        str += ': ' + this.$t('department') + ' ' + this.department.name;
      }
      return str;
    }
  },
  i18n: {
    messages: {
      en: {
        kpiSetup: 'KPI setup',
        group: 'Group',
        department: 'Department',
        appliedTime: 'Applied time',
        salesTarget: 'Sales target',
        salesAchieved: 'Sales achieved',
        month: 'Month',
        year: 'Year',
        chooseMonth: 'Choose month',
        appliedTo: 'Applied to',
        appliedToGroup: 'Group',
        appliedToDepartment: 'Department',
        chooseAppliedTo: 'Applied to',
        sales: 'Sales'
      },
      vi: {
        kpiSetup: 'Cài đặt KPI',
        group: 'Nhóm',
        department: 'Phòng',
        appliedTime: 'Thời gian áp dụng',
        salesTarget: 'Doanh số mục tiêu',
        salesAchieved: 'Đã đạt được',
        month: 'Tháng',
        year: 'Năm',
        chooseMonth: 'Chọn tháng',
        appliedTo: 'Áp dụng cho',
        appliedToGroup: 'Nhóm',
        appliedToDepartment: 'Phòng',
        chooseAppliedTo: 'Áp dụng cho',
        sales: 'Doanh số'
      }
    }
  }
}
</script>

<style scoped>

</style>